import { Instance } from 'mobx-state-tree'

import { GameSnapshotModelBase } from './GameSnapshotModel.base'

/* The TypeScript type of an instance of GameSnapshotModel */
export interface GameSnapshotModelType extends Instance<typeof GameSnapshotModel> {}

/* A graphql query fragment builders for GameSnapshotModel */
export {
  selectFromGameSnapshot,
  gameSnapshotModelPrimitives,
  GameSnapshotModelSelector
} from './GameSnapshotModel.base'

/**
 * GameSnapshotModel
 */
export const GameSnapshotModel = GameSnapshotModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
